import {WeighingDataDto, WeighingTypeDto} from "../../api/kpi";
import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {validationStore} from "../ValidationStore";
import {WeighingCreateFormData} from "../../components/page/kpi/WeighingCreateForm";
import {KpiCustomerItem} from "./KpiCustomerStore";

class KpiWeighingCreateStore {
    get customer(): KpiCustomerItem | undefined {
        return this._customer;
    }

    set customer(value: KpiCustomerItem | undefined) {
        this._customer = value;
    }
    get type(): WeighingTypeDto {
        return this._type;
    }

    set type(value: WeighingTypeDto) {
        this._type = value;
    }

    get date(): string {
        return this._date;
    }

    set date(value: string) {
        this._date = value;
    }

    get amount(): string {
        return this._amount;
    }

    set amount(value: string) {
        this._amount = value;
    }

    get valid(): boolean {
        return this._valid;
    }

    set valid(value: boolean) {
        this._valid = value;
    }

    get creating(): boolean {
        return this._creating;
    }

    set creating(value: boolean) {
        this._creating = value;
    }

    private _creating: boolean = false
    private _valid: boolean = false

    private _amount: string = ''
    private _date: string = new Date(Date.now()).toISOString().split('T')[0]
    private _type: WeighingTypeDto = WeighingTypeDto.INCOMING
    private _customer: KpiCustomerItem | undefined


    constructor() {
        makeAutoObservable(this)
    }


    public build(): WeighingDataDto {
        const {
            amount,
            customer,
            date,
            type
        } = this
        const floatAmount = parseFloat(amount)

        return {
            amount: isNaN(floatAmount) ? 0 : floatAmount,
            customerId: customer?.id || '',
            date,
            type,
        }
    }

    get formData(): WeighingCreateFormData {
        const {
            amount,
            customer,
            date,
            type
        } = this
        return {
            amount: `${amount}`,
            customer,
            date,
            type,
        }
    }

    set formData(data: WeighingCreateFormData) {
        const {
            amount,
            customer,
            date,
            type
        } = data
        this._amount = amount
        this.customer = customer
        this._date = date
        this._type = type
    }


    async create(): Promise<boolean> {
        this.creating = true
        await this.validate()
        if (this.valid) {
            const data = this.build()
            await catchApi(async () => await api.kpi.api.createWeighing(data))
            this.creating = false
            this.reset()
            return true
        }
        this.creating = false
        return false
    }

    async validate() {
        this.valid = false
        const dto = this.build()
        await validationStore.validate(api.kpi.api.validateWeighing, dto)

        this.valid = Boolean(validationStore.valid)
    }

    reset(validate?: boolean) {
        this.amount = ''
        if (validate) {
            this.validate().finally()
        }
    }
}

const kpiWeighingCreateStore = new KpiWeighingCreateStore()

export {
    kpiWeighingCreateStore
}
